const resourceUrl = 'https://saas-files.oss-cn-shenzhen.aliyuncs.com/'

export {resourceUrl}